export default {
  title: "Confirm removal",
  body_description:
    "Are you sure you want to remove this <b class='text-info'>Attachment</b> from the <b class='text-info'>{entity}</b>? | Are you sure you want to remove these <b class='text-info'>Attachments</b> from the <b class='text-info'>{entity}</b>?",
  body_warning: "This is irreversible!",
}
